import { render } from "./add-sales.vue?vue&type=template&id=78f3ff70&scoped=true"
import script from "./add-sales.vue?vue&type=script&lang=js"
export * from "./add-sales.vue?vue&type=script&lang=js"

import "./add-sales.vue?vue&type=style&index=0&id=78f3ff70&scoped=true&lang=css"
import "./add-sales.vue?vue&type=style&index=1&id=78f3ff70&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f3ff70"]])

export default __exports__